import styled from "styled-components";
import { ScreenSizes } from "../../../styles/Themes";
import { useDispatch } from "react-redux";
import { componentActions } from "../../../store/componentSlice";
import { useEffect } from "react";
import { useState } from "react";

const EndStageVideoEl = styled.video`
  width: 840px;
  height: auto;
  @media (max-width: ${ScreenSizes.mobile}) {
    width: 100%;
  }
`;

const EndStageImageEl = styled.img`
  width: 840px;
  height: auto;
  @media (max-width: ${ScreenSizes.mobile}) {
    width: 100%;
  }
`;

function EndStageVideo({ showData }) {
  const dispatch = useDispatch();

  function endStageRedeemModalHandler(isOpen) {
    dispatch(componentActions.setIsRedeemModalOpen(isOpen));
    dispatch(componentActions.setIsBlur(true));
  }

  const [isVideo, setIsVideo] = useState(true);
  useEffect(() => {
    if (showData.publicData.redeemAssetMedia) {
      const urlArr = showData.publicData.redeemAssetMedia.split(".");
      const ext = urlArr[urlArr.length - 1];
      if (ext !== "mp4") {
        setIsVideo(false);
      }
    }
  }, [showData]);
  return (
    <>
      {isVideo ? (
        <EndStageVideoEl
          autoPlay
          muted
          loop
          playsInline
          onClick={(e) => endStageRedeemModalHandler(true)}
        >
          <source src={showData.publicData.redeemAssetMedia} type="video/mp4" />
        </EndStageVideoEl>
      ) : (
        <EndStageImageEl src={showData.publicData.redeemAssetMedia} />
      )}
    </>
  );
}
export default EndStageVideo;
